export const DAO_CODE = 'BANK' + '_DAO';
